import store from '@/store';
export const hasAuth = (id) => {
    return store.getters.getUserCloudSystem.includes(id); 
}
export default {
    inserted(el, binding, vnode) {
        if (!hasAuth(binding.value)) {
            el.remove()
        }
    },
    update(el, binding) {
    },
    unbind(el, binding) {
    }
};